import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

const AppointmentIcon: React.FC<IconProps> = (props) => (

  <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" {...props} xmlns="http://www.w3.org/2000/svg">
<path d="M8.375 9.43125V7.125H9.3125V8.8875L10.8375 9.76875L10.3688 10.5813L8.375 9.43125ZM0.875 12.75V0.875H12.125V5.9375C12.9 6.725 13.375 7.80625 13.375 9C13.375 11.4187 11.4187 13.375 9 13.375C8.39771 13.3767 7.80166 13.2531 7.24969 13.0121C6.69773 12.7711 6.20192 12.4179 5.79375 11.975L4.625 12.75L2.75 11.5L0.875 12.75ZM5.04375 7.125C5.26875 6.65625 5.5625 6.23125 5.9375 5.875H3.375V7.125H5.04375ZM9.625 4.625V3.375H3.375V4.625H9.625ZM9 12.125C10.725 12.125 12.125 10.725 12.125 9C12.125 7.275 10.725 5.875 9 5.875C7.275 5.875 5.875 7.275 5.875 9C5.875 10.725 7.275 12.125 9 12.125Z" fill="currentColor"/>
</svg>

);

export default AppointmentIcon;


